import React, { useEffect } from "react";
import { Helmet } from "react-helmet-async";
import { Box, Button, Typography } from "@mui/material";

import Banner from "./Banner";
import QuintetDestinations from "./QuintetDestinations";
import JourneyMatters from "./JourneyMatters";
import HaveQuestions from "../../components/HaveQuestions";

// Practice BuiltContainer
import BuildOutlinedIcon from "@mui/icons-material/BuildOutlined";
import WorkOutlineOutlinedIcon from "@mui/icons-material/WorkOutlineOutlined";
import Groups_2OutlinedIcon from "@mui/icons-material/LocalOfferOutlined";
import AutoStoriesOutlinedIcon from "@mui/icons-material/AutoStoriesOutlined";
import LocalOfferOutlinedIcon from "@mui/icons-material/LocalOfferOutlined";
import VerifiedUserOutlinedIcon from "@mui/icons-material/VerifiedUserOutlined";

// Banner
import bgImage from "../../assets/DAMJourneyBg-PS.png";
const bannerTitle = "DAM Journey";
const bannerDesc = "We walk with you through your Asset Lifecycle Management journey";

// Practice Built Container
const practiceBuiltTitle = "A Practice Built on Knowledge and Experience";
const practiceBuiltDesc =
  "We are more than consultants—we are practitioners. Our approach is rooted in hands-on experience, real-world execution, and deep expertise in Digital Asset Management. We work alongside your team to design, implement, and optimize DAM solutions that deliver measurable results.";

const practiceBuiltCards = [
  {
    title: "Hands-On Execution",
    description: "We actively implement solutions, not just recommend strategies.",
    icon: BuildOutlinedIcon,
  },
  {
    title: "Real-World Experience",
    description:
      "Our expertise is built from working on real DAM projects across industries.",
    icon: WorkOutlineOutlinedIcon,
  },
  {
    title: "Collaborative Approach",
    description: "We work as an extension of your team throughout the journey.",
    icon: Groups_2OutlinedIcon,
  },
  {
    title: "Continuous Learning",
    description: "We evolve with industry trends, tools, and best practices.",
    icon: AutoStoriesOutlinedIcon,
  },
  {
    title: "Metadata & Taxonomy",
    description: "Organize assets with structured metadata for easy search and access.",
    icon: LocalOfferOutlinedIcon,
  },
  {
    title: "Governance & Compliance",
    description: "Ensure secure, standardized, and compliant asset management practices.",
    icon: VerifiedUserOutlinedIcon,
  },
];

const DamJourneyPage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <Box sx={{ backgroundColor: "#F9F9F9" }}>
      <Helmet>
        <title>DAM Journey - DAM Journey</title>
        <meta
          name="description"
          content="DAM Journey, We walk with you through your Asset Lifecycle Management journey"
        />
        <meta
          property="keywords"
          content="DAM, DAM Journey, DAM Practice, DAM Consultant, DAM Consulting, DAM Practitioner, DAM Service, DAM Product, DAM Discovery, DAM Implementation, DAM Deployment, DAM Journey"
        />
      </Helmet>
      <Box /*sx={{ maxWidth: "1440px" }}*/>
        <Banner title={bannerTitle} description={bannerDesc} image={bgImage} />
        <QuintetDestinations />
        <JourneyMatters />
        <HaveQuestions />
      </Box>
    </Box>
  );
};

export default DamJourneyPage;
